/**
 * @generated SignedSource<<360aba9e613d8d1da984eeee645c598b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell$data = {
  readonly hoverOrFocusState?: {
    readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
  } | null | undefined;
  readonly statusCategory: {
    readonly name: string | null | undefined;
    readonly statusCategoryId: string;
  };
  readonly " $fragmentType": "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell";
};
export type issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell$key = {
  readonly " $data"?: issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "issueStatusCategory_nativeIssueTable_IssueStatusCategoryCell",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "statusCategoryId"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "concreteType": "JiraFieldHoverOrFocusState",
              "kind": "LinkedField",
              "name": "hoverOrFocusState",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
};

(node as any).hash = "e1eaf1499cb20a8eff0834cabc049d84";

export default node;
